import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Button, Tooltip, IconButton, ToggleButton, Badge, Box } from '@mui/material';
// hooks
import { useResponsive } from '../../../hooks';
// components
import { Iconify } from '../../../components';
// constant
import { VIEW_OPTIONS } from '../../../constants/CalenderConst';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(2.5),
    [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}));

export default function CalendarToolbar({ title, view, onToday, onNextDate, onPrevDate, onChangeView, onOpenFilter, canReset }) {
    const isDesktop = useResponsive('up', 'sm');

    return (
        <RootStyle>
            {isDesktop && (
                <Stack direction="row" spacing={0.75}>
                    {VIEW_OPTIONS.map((viewOption) => (
                        <Tooltip key={viewOption.value} title={viewOption.label}>
                            <ToggleButton
                                value={view}
                                selected={viewOption.value === view}
                                onChange={() => onChangeView(viewOption.value)}
                                sx={{
                                  width: 36,
                                  height: 36,
                                  p: 0,
                                  borderRadius: 1.25,
                                  border: (theme) => `solid 1px ${theme.palette.divider}`,
                                  color: 'text.secondary',
                                  '&.Mui-selected': {
                                    color: 'text.primary',
                                    borderColor: 'text.primary',
                                    bgcolor: 'background.paper',
                                  },
                                }}
                            >
                                <Iconify icon={viewOption.icon} width={20} height={20} />
                            </ToggleButton>
                        </Tooltip>
                    ))}
                </Stack>
            )}

            <Stack direction="row" alignItems="center" spacing={2}>
                <IconButton onClick={onPrevDate}>
                    <Iconify icon="eva:arrow-ios-back-fill" width={20} height={20} />
                </IconButton>

                <Box sx={{ typography: { xs: 'subtitle2', sm: 'h6' } }}>{title}</Box>

                <IconButton onClick={onNextDate}>
                    <Iconify icon="eva:arrow-ios-forward-fill" width={20} height={20} />
                </IconButton>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                {isDesktop && (
                    <Button size="small" color="error" variant="contained" onClick={onToday}>
                        Today
                    </Button>
                )}

                <IconButton onClick={onOpenFilter}>
                    <Badge color="error" variant="dot" invisible={!canReset}>
                        <Iconify icon="ic:round-filter-list" />
                    </Badge>
                </IconButton>
            </Stack>
        </RootStyle>
    );
}

CalendarToolbar.propTypes = {
  title: PropTypes.string,
  onToday: PropTypes.func,
  onNextDate: PropTypes.func,
  onPrevDate: PropTypes.func,
  onChangeView: PropTypes.func,
  onOpenFilter: PropTypes.func,
  canReset: PropTypes.bool,
  view: PropTypes.oneOf(['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listWeek']),
};
